// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/storefront/v1/brand.proto (package kitecorp.transferify.storefront.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/storefront/v1/brand.proto.
 */
export const file_kitecorp_transferify_storefront_v1_brand: GenFile = /*@__PURE__*/
  fileDesc("Ci5raXRlY29ycC90cmFuc2ZlcmlmeS9zdG9yZWZyb250L3YxL2JyYW5kLnByb3RvEiJraXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxIo0BCgVCcmFuZBIVCghsb2dvX3VybBgBIAEoCUgAiAEBEhoKDXByaW1hcnlfY29sb3IYAiABKAlIAYgBARIdChBvbl9wcmltYXJ5X2NvbG9yGAMgASgJSAKIAQFCCwoJX2xvZ29fdXJsQhAKDl9wcmltYXJ5X2NvbG9yQhMKEV9vbl9wcmltYXJ5X2NvbG9yIhEKD0dldEJyYW5kUmVxdWVzdCJMChBHZXRCcmFuZFJlc3BvbnNlEjgKBWJyYW5kGAEgASgLMikua2l0ZWNvcnAudHJhbnNmZXJpZnkuc3RvcmVmcm9udC52MS5CcmFuZCJEChRTZXRCcmFuZENvbG9yUmVxdWVzdBIaCg1wcmltYXJ5X2NvbG9yGAEgASgJSACIAQFCEAoOX3ByaW1hcnlfY29sb3IiUQoVU2V0QnJhbmRDb2xvclJlc3BvbnNlEjgKBWJyYW5kGAEgASgLMikua2l0ZWNvcnAudHJhbnNmZXJpZnkuc3RvcmVmcm9udC52MS5CcmFuZCITChFSZXNldEJyYW5kUmVxdWVzdCJOChJSZXNldEJyYW5kUmVzcG9uc2USOAoFYnJhbmQYASABKAsyKS5raXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxLkJyYW5kMq8DCgxCcmFuZFNlcnZpY2USgwEKCEdldEJyYW5kEjMua2l0ZWNvcnAudHJhbnNmZXJpZnkuc3RvcmVmcm9udC52MS5HZXRCcmFuZFJlcXVlc3QaNC5raXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxLkdldEJyYW5kUmVzcG9uc2UiDJACAYq1GAUKA3VzZRKPAQoNU2V0QnJhbmRDb2xvchI4LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LnN0b3JlZnJvbnQudjEuU2V0QnJhbmRDb2xvclJlcXVlc3QaOS5raXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxLlNldEJyYW5kQ29sb3JSZXNwb25zZSIJirUYBQoDdXNlEoYBCgpSZXNldEJyYW5kEjUua2l0ZWNvcnAudHJhbnNmZXJpZnkuc3RvcmVmcm9udC52MS5SZXNldEJyYW5kUmVxdWVzdBo2LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LnN0b3JlZnJvbnQudjEuUmVzZXRCcmFuZFJlc3BvbnNlIgmKtRgFCgN1c2VCQAowY29tLmtpdGVjb3JwLmNvbnRyYWN0cy50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxQgpCcmFuZFByb3RvUAFiBnByb3RvMw", [file_kitecorp_options_v1_options]);

/**
 * The sender's brand. A value the sender has not set is absent.
 *
 * @generated from message kitecorp.transferify.storefront.v1.Brand
 */
export type Brand = Message<"kitecorp.transferify.storefront.v1.Brand"> & {
  /**
   * The address of the logo, served to every recipient without a session.
   *
   * @generated from field: optional string logo_url = 1;
   */
  logoUrl?: string | undefined;

  /**
   * The brand colour, as #rrggbb.
   *
   * @generated from field: optional string primary_color = 2;
   */
  primaryColor?: string | undefined;

  /**
   * The colour of the text over the brand colour, chosen by the server so it stays readable.
   *
   * @generated from field: optional string on_primary_color = 3;
   */
  onPrimaryColor?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.Brand.
 * Use `create(BrandSchema)` to create a new message.
 */
export const BrandSchema: GenMessage<Brand> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_brand, 0);

/**
 * Asks for the brand of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetBrandRequest
 */
export type GetBrandRequest = Message<"kitecorp.transferify.storefront.v1.GetBrandRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetBrandRequest.
 * Use `create(GetBrandRequestSchema)` to create a new message.
 */
export const GetBrandRequestSchema: GenMessage<GetBrandRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_brand, 1);

/**
 * The brand of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetBrandResponse
 */
export type GetBrandResponse = Message<"kitecorp.transferify.storefront.v1.GetBrandResponse"> & {
  /**
   * The brand, with every unset value absent.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.Brand brand = 1;
   */
  brand?: Brand | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetBrandResponse.
 * Use `create(GetBrandResponseSchema)` to create a new message.
 */
export const GetBrandResponseSchema: GenMessage<GetBrandResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_brand, 2);

/**
 * Sets the brand colour.
 *
 * @generated from message kitecorp.transferify.storefront.v1.SetBrandColorRequest
 */
export type SetBrandColorRequest = Message<"kitecorp.transferify.storefront.v1.SetBrandColorRequest"> & {
  /**
   * The new colour, as #rrggbb. Absent clears the colour and keeps the logo.
   *
   * @generated from field: optional string primary_color = 1;
   */
  primaryColor?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.SetBrandColorRequest.
 * Use `create(SetBrandColorRequestSchema)` to create a new message.
 */
export const SetBrandColorRequestSchema: GenMessage<SetBrandColorRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_brand, 3);

/**
 * The brand after the change.
 *
 * @generated from message kitecorp.transferify.storefront.v1.SetBrandColorResponse
 */
export type SetBrandColorResponse = Message<"kitecorp.transferify.storefront.v1.SetBrandColorResponse"> & {
  /**
   * The brand as stored.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.Brand brand = 1;
   */
  brand?: Brand | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.SetBrandColorResponse.
 * Use `create(SetBrandColorResponseSchema)` to create a new message.
 */
export const SetBrandColorResponseSchema: GenMessage<SetBrandColorResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_brand, 4);

/**
 * Asks to clear the logo and the colour.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ResetBrandRequest
 */
export type ResetBrandRequest = Message<"kitecorp.transferify.storefront.v1.ResetBrandRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ResetBrandRequest.
 * Use `create(ResetBrandRequestSchema)` to create a new message.
 */
export const ResetBrandRequestSchema: GenMessage<ResetBrandRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_brand, 5);

/**
 * The brand after the reset.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ResetBrandResponse
 */
export type ResetBrandResponse = Message<"kitecorp.transferify.storefront.v1.ResetBrandResponse"> & {
  /**
   * The brand, with every value absent.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.Brand brand = 1;
   */
  brand?: Brand | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ResetBrandResponse.
 * Use `create(ResetBrandResponseSchema)` to create a new message.
 */
export const ResetBrandResponseSchema: GenMessage<ResetBrandResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_brand, 6);

/**
 * The sender's brand: the logo and the colour a recipient sees on the page and in the mail (kitecorp/contracts#74).
 * Each call reads or changes the brand of the signed-in account.
 *
 * @generated from service kitecorp.transferify.storefront.v1.BrandService
 */
export const BrandService: GenService<{
  /**
   * Reads the brand of the signed-in account.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.BrandService.GetBrand
   */
  getBrand: {
    methodKind: "unary";
    input: typeof GetBrandRequestSchema;
    output: typeof GetBrandResponseSchema;
  },
  /**
   * Sets the brand colour and keeps the logo. A request without a colour clears the colour.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.BrandService.SetBrandColor
   */
  setBrandColor: {
    methodKind: "unary";
    input: typeof SetBrandColorRequestSchema;
    output: typeof SetBrandColorResponseSchema;
  },
  /**
   * Clears the logo and the colour.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.BrandService.ResetBrand
   */
  resetBrand: {
    methodKind: "unary";
    input: typeof ResetBrandRequestSchema;
    output: typeof ResetBrandResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_storefront_v1_brand, 0);

